import React, { useState, useRef, useEffect } from 'react';
import styles from './Toolbar.module.css';

const Toolbar = ({
    tools = [],
    activeTool,
    onToolChange,
    orientation = 'horizontal',
    showLabels = true,
    className = '',
    floating = false,
    children
}) => {
    const visibleTools = tools;

    return (
        <div
            className={`${styles.toolbar} ${styles[orientation]} ${floating ? styles.floating : ''} ${className}`}
            role="toolbar"
            aria-label="Панель инструментов"
        >
            {visibleTools.map((group, index) => (
                <div key={index} className={styles.toolGroup}>
                    {group.items?.map((item) => (
                        <button
                            key={item.id}
                            className={`${styles.toolButton} ${(activeTool === item.id || item.active) ? styles.active : ''}`}
                            onClick={() => onToolChange?.(item.id)}
                            disabled={item.disabled}
                            title={item.title || item.label}
                            aria-label={item.label}
                            aria-pressed={activeTool === item.id}
                        >
                            <span className={styles.toolIcon}>{item.icon}</span>
                            {showLabels && !floating && (
                                <span className={styles.toolName}>{item.label}</span>
                            )}
                        </button>
                    ))}
                </div>
            ))}

            {children && (
                <div className={styles.toolGroup}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default Toolbar;
